module.exports = __webpack_public_path__ + "static/media/StrengthsIdentification.4d1ec091.jpg";